import $ from 'jquery';
import _ from 'underscore';
import Backbone from "backbone";
import OptionPopupView from "views/common/OptionPopupView";
import PersistentModels from "services/PersistentModels";
import ti18n from "i18n!nls/CapsuleDetailsi18n";
import popupTemplate from 'text!../../../templates/capsule/CapsuleListOptionTemplate.html';

const CapsuleListOptionView = OptionPopupView.extend({

    
    initialize: function(options) {
        const viewOptions = {};
        const contentView = {};
        const contentViewTemplate = _.template(popupTemplate);
        const templateParams = {"ti18n": ti18n};
        contentView.$el = $(contentViewTemplate(templateParams));
        this._listView = options.capsuleListView?options.capsuleListView: null;
        if(this._listView){
            $(contentView.$el[2]).append(this._listView.$el);
        }
        viewOptions.contentView = contentView;
        viewOptions.addContentAfterEnhancement = true;
        viewOptions.contentPosition = "top";
        this._popupUniqueId = "CapsuleListOptionViewPopup";
        viewOptions.id = this._popupUniqueId;
        OptionPopupView.prototype.initialize.call(this, viewOptions);
        PersistentModels.getInstance().getRouter().registerForViewportHeightChange(this._popupUniqueId,this.onOrientationChangeFunction.bind(this), true);
    },
    
    hideCreateCapsuleButton : function(){
        this.$el.find("#createNewCapsuleBtn").hide();
    },
    
    showCreateCapsuleButton : function(){
        this.$el.find("#createNewCapsuleBtn").show();
    },
    
    onCreateCapsuleBtnTapped : function(){
        this.trigger("createCapsule");
    },
    
    onOrientationChangeFunction  : function(newViewPortHeigh, forceResizing) {
        if(this.$el.is(":visible") || forceResizing){
            if (this.el) {
                const adjustedListContainerHeight = (newViewPortHeigh) ;
                this.$el.find(".ui-content").css("height", adjustedListContainerHeight + "px");
                this._listView._displayInfoBoxIfApplicable();
                this._listView._onRootElementResize();
            }
        }
    },

    afterRendering: function() {
       
    },

    
    onPopupClosed: function() {
        OptionPopupView.prototype.onPopupClosed.call(this);
        PersistentModels.getInstance().getRouter().unRegisterForViewportHeightChange(this._popupUniqueId, true);
        this.trigger("deleteAllRecordings");
    },

    
    onAfterPageShow: function() {
    //this.$el.find("#comment").focus();
        this.onOrientationChangeFunction(PersistentModels.getInstance().getRouter().getViewportHeight(), true);
        this.$el.find("#createNewCapsuleBtn").on("click",this.onCreateCapsuleBtnTapped.bind(this) );
    },



});

export default CapsuleListOptionView;
